/* Package */
import { addDays, format } from 'date-fns'

/* Types */
import { Basket as BasketApi, DeliveryMethods } from '@/types/api/api-v3/basket'
import { Basket, BasketState } from '@/types/store/basket'
import { DateTimeChoices } from '@/store/basket/basket.types'

// TODO: Переработать неработающий функционал
/**
 * Получаем список дней текущего месяца с date-fns
 */
export const getListOfMonth = () => {
  const todayDate = new Date()
  const finalDate = addDays(new Date(), 30)

  const currentDate = format(new Date(), 'yyyy-MM-dd')
  const result: DateTimeChoices[] = [
    {
      value: currentDate,
      text: currentDate,
    },
  ]

  // eslint-disable-next-line no-unmodified-loop-condition
  while (todayDate < finalDate) {
    const date = format(
      todayDate.setDate(todayDate.getDate() + 1),
      'yyyy-MM-dd',
    )
    result.push({
      value: date,
      text: date,
    })
  }

  return result
}

// TODO: Разобраться с типизацией
/**
 * Формируем state корзины
 * @param basket - данные корзины с api
 * @param state - текущий state корзины
 * @param defaultState - default состояние корзины
 */
export const getBasketState = (
  basket: BasketApi,
  state: BasketState,
  defaultState: BasketState,
) => {
  const basketState: Basket = {
    totalPrice: basket.total_price || defaultState.data.totalPrice,
    totalAmount: basket.total_amount || defaultState.data.totalAmount,
    amountToPay: basket.amount_to_pay || defaultState.data.amountToPay,
    itemsCount: basket.items_count || defaultState.data.itemsCount,
    items: basket.items || defaultState.data.items,
    maxNumberOfPersons:
      basket.max_number_of_persons || defaultState.data.maxNumberOfPersons,
    persons: basket.persons
      ? {
          errorMessage:
            basket.persons.error_message ||
            defaultState.data.persons.errorMessage,
          helpMessage:
            basket.persons.help_message ||
            defaultState.data.persons.helpMessage,
          message: basket.persons.message || defaultState.data.persons.message,
          maxNumber:
            basket.persons.max_number || defaultState.data.persons.maxNumber,
          number: basket.persons.number || defaultState.data.persons.number,
        }
      : undefined,
    promocode: {
      discountAmount:
        basket.promo_code?.discount_amount ||
        defaultState.data.promocode.discountAmount,
      title: basket.promo_code?.title || defaultState.data.promocode.title,
      valid: basket.promo_code?.valid ?? defaultState.data.promocode.valid,
      error: basket.promo_code?.error || defaultState.data.promocode.error,
      type: basket.promo_code?.type || defaultState.data.promocode.type,
      value: basket.promo_code?.value || defaultState.data.promocode.value,
    },
    clientPacks: basket.client_packs || defaultState.data.clientPacks,
    additives: basket.additives || defaultState.data.additives,
    gifts: basket.gifts || defaultState.data.gifts,
    delivery: {
      cost: basket.delivery?.cost || defaultState.data.delivery.cost,
      method: basket.delivery?.method || defaultState.data.delivery.method,
      addresses: {
        [DeliveryMethods.COURIER]:
          basket.delivery?.method === DeliveryMethods.COURIER
            ? basket.delivery?.address_id
            : defaultState.data.delivery.addresses.courier,
        [DeliveryMethods.HALL]:
          basket.delivery?.method === DeliveryMethods.HALL
            ? basket.delivery?.point_id
            : defaultState.data.delivery.addresses.hall,
        [DeliveryMethods.PICKUP]:
          basket.delivery?.method === DeliveryMethods.PICKUP
            ? basket.delivery?.point_id
            : defaultState.data.delivery.addresses.pickup,
      },
    },
    bonuses: {
      toAccrueAmount:
        basket.bonuses?.to_accrue_amount ||
        defaultState.data.bonuses.toAccrueAmount,
      errorMessage:
        basket.bonuses?.error_message || defaultState.data.bonuses.errorMessage,
      maxSpendAmount:
        basket.bonuses?.max_spend_amount ||
        defaultState.data.bonuses.maxSpendAmount,
      message: basket.bonuses?.message || defaultState.data.bonuses.message,
      toSpendAmount:
        basket.bonuses?.to_spend_amount ||
        defaultState.data.bonuses.toSpendAmount,
      totalAmount:
        basket.bonuses?.total_amount || defaultState.data.bonuses.totalAmount,
    },
    selectedPaymentMethod: state.data.selectedPaymentMethod,
    note: state.data.note,
    change: state.data.change,
    selectedGifts: state.data.selectedGifts,
    proposition: {
      timeToLive:
        basket.proposition?.time_to_live ||
        defaultState.data.proposition.timeToLive,
      popupText:
        basket.proposition?.popup_text ||
        defaultState.data.proposition.popupText,
      items: basket.proposition?.items || defaultState.data.proposition.items,
    },
    doNotCallMeBack: state.data.doNotCallMeBack,
    isExtra: basket.is_extra || defaultState.data.isExtra,
  }

  if (basket.items_count === 0) {
    basketState.selectedPaymentMethod = defaultState.data.selectedPaymentMethod
    basketState.note = defaultState.data.note
  }

  return basketState
}
